import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformCountryRequiresWhatsappStatus } from './country-requires-whatsapp.transformer';
import type { CountryRequiresWhatsappCollection } from './country-requires-whatsapp.types';

export function countryRequiresWhatsappReducer(
  state: CollectionStateSlice<CountryRequiresWhatsappCollection> = {},
  action: CollectionActions<CountryRequiresWhatsappCollection>,
): CollectionStateSlice<CountryRequiresWhatsappCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'countryRequiresWhatsapp') {
        const { result, ref, order } = action.payload;
        const queryId = getQueryParamValue(ref.query, 'id')[0];
        const countryCode =
          ref.path.ids?.[0] ?? (Array.isArray(queryId) ? queryId[0] : queryId);
        if (!countryCode) {
          return state;
        }
        return mergeDocuments<CountryRequiresWhatsappCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformCountryRequiresWhatsappStatus,
            countryCode,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
